import React from 'react';
import { TCloseIconProps } from './CloseIcon.types';

const CloseIcon: React.FC<TCloseIconProps> = (props: TCloseIconProps): React.ReactElement => {
  const { color, width, height } = props;

  return <svg width={width || '42'} height={height || '42'} viewBox="0 0 42 42" fill="none"
              xmlns="http://www.w3.org/2000/svg">
    <rect x="38.1838" y="41.7195" width="54" height="5" transform="rotate(-135 38.1838 41.7195)"
          fill={color || 'white'}/>
    <rect y="38.1838" width="54" height="5" transform="rotate(-45 0 38.1838)" fill={color || 'white'}/>
  </svg>;
};

export default CloseIcon;
